var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgComputer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "current",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.26087 11.6636C1.82029 11.6636 1.44638 11.5006 1.13913 11.1746C0.831884 10.8486 0.678261 10.4623 0.678261 10.0155V1.66624C0.678261 1.19534 0.831884 0.799914 1.13913 0.479948C1.44638 0.159983 1.82029 0 2.26087 0H13.7391C14.1913 0 14.571 0.159983 14.8783 0.479948C15.1855 0.799914 15.3391 1.19534 15.3391 1.66624V10.0155C15.3391 10.4623 15.1855 10.8486 14.8783 11.1746C14.571 11.5006 14.1913 11.6636 13.7391 11.6636H2.26087ZM0.608696 14C0.423188 14 0.275362 13.9396 0.165217 13.8189C0.0550725 13.6981 0 13.5472 0 13.3661C0 13.1729 0.0550725 13.022 0.165217 12.9133C0.275362 12.8047 0.423188 12.7503 0.608696 12.7503H15.4087C15.5826 12.7503 15.7246 12.8077 15.8348 12.9224C15.9449 13.0371 16 13.179 16 13.348C16 13.5412 15.9449 13.6981 15.8348 13.8189C15.7246 13.9396 15.5826 14 15.4087 14H0.608696Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComputer);
export default __webpack_public_path__ + "static/media/computer.6469478a741e81a233277e5e81e18de6.svg";
export { ForwardRef as ReactComponent };